module.exports = __webpack_public_path__ + "static/img/t2-1-1.e0f4f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t2-1-1.png
// module id = JraJ
// module chunks = 1